import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { SystemRoutingModule } from '@business/system/system-routing.module';
import { SystemInfoComponent } from './components/system-info/system-info.component';

@NgModule({
  imports: [SharedModule, SystemRoutingModule],
  declarations: [SystemInfoComponent],
})
export class SystemModule {}
